/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenTabletHIcon32Regular = forwardRef('TechScreenTabletHIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M8 21a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 4A5.5 5.5 0 0 0 2 9.5v13A5.5 5.5 0 0 0 7.5 28h17a5.5 5.5 0 0 0 5.5-5.5v-13A5.5 5.5 0 0 0 24.5 4h-17ZM4 9.5A3.5 3.5 0 0 1 7.5 6h17A3.5 3.5 0 0 1 28 9.5v13a3.5 3.5 0 0 1-3.5 3.5h-17A3.5 3.5 0 0 1 4 22.5v-13Z" })));
});
